import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Typography } from 'antd';
import { useUpdateCargoCmrReceived } from 'api/cargos/use-update-cargo-cmr-received';
import type { ICargoCmrReceivedUpdateModalProps } from './types';

export const CargoCmrReceivedUpdateModal: React.FC<ICargoCmrReceivedUpdateModalProps> = (props) => {
  const { isOpen, onClose, cmrReceived, cargoId } = props;
  const { t } = useTranslation('cargo');

  const { mutateAsync: updateCmrReceived, isLoading } = useUpdateCargoCmrReceived(cargoId);

  const onFinish = async () => {
    await updateCmrReceived({
      cmrReceived: !cmrReceived,
    });
    onClose();
  };

  const modalTitle = cmrReceived ? t('mark_cmr_not_received') : t('mark_cmr_received');

  const confirmationMessage = cmrReceived ? t('confirm_cmr_not_received_message') : t('confirm_cmr_received_message');

  return (
    <Modal title={modalTitle} open={isOpen} confirmLoading={isLoading} onCancel={onClose} onOk={onFinish}>
      <Typography.Text>{confirmationMessage}</Typography.Text>
    </Modal>
  );
};
